export const foodPreferencesOptions = [
  { label: 'Booking.vegan', name: 'vegan' },
  { label: 'Booking.vegetarian', name: 'vegetarian' }
];

export const healthNeeds = [{ label: 'Booking.handicapped', name: 'handicapped' }];

export const additionalCustomCheckboxFields = [
  { label: 'Booking.customField', name: 'checkboxCustomField1' },
  { label: 'Booking.customField', name: 'checkboxCustomField2' },
  { label: 'Booking.customField', name: 'checkboxCustomField3' }
];

export const bookingRegions = [
  {
    id: 0,
    value: 'Booking.none'
  },
  {
    id: 1,
    value: 'Booking.Regions.badenWürttemberg'
  },
  {
    id: 2,
    value: 'Booking.Regions.bavaria'
  },
  {
    id: 3,
    value: 'Booking.Regions.berlin'
  },
  {
    id: 4,
    value: 'Booking.Regions.brandenburg'
  },
  {
    id: 5,
    value: 'Booking.Regions.bremen'
  },
  {
    id: 6,
    value: 'Booking.Regions.hamburg'
  },
  {
    id: 7,
    value: 'Booking.Regions.hesse'
  },
  {
    id: 8,
    value: 'Booking.Regions.lowerSaxony'
  },
  {
    id: 9,
    value: 'Booking.Regions.mecklenburgWesternOmerania'
  },
  {
    id: 10,
    value: 'Booking.Regions.northrhineWestphalia'
  },
  {
    id: 11,
    value: 'Booking.Regions.rhinelandPalatinate'
  },
  {
    id: 12,
    value: 'Booking.Regions.saarland'
  },
  {
    id: 13,
    value: 'Booking.Regions.saxony'
  },
  {
    id: 14,
    value: 'Booking.Regions.saxonyAnhalt'
  },
  {
    id: 15,
    value: 'Booking.Regions.schleswigHolstein'
  },
  {
    id: 16,
    value: 'Booking.Regions.thuringia'
  }
];
